import * as React from 'react'

import { StoreOfferProduct } from '@common'
import cx from 'classnames'

import { BrawlStarsHeading } from './components/BrawlStarsHeading'
import { BrawlStarsOfferCardContent } from './components/BrawlStarsOfferCardContent'
import { Countdown, Footer, ValueBadge } from '../../../shared'
import { Container } from '../../shared/Container'
import { Ribbon, Ribbons } from '../../shared/Ribbons'

import styles from './BrawlStarsOfferCard.module.scss'

type Props = {
  product: StoreOfferProduct
  ribbons: Ribbon[]
}

export function BrawlStarsOfferCard({ product, ribbons }: Props) {
  const isMultiItemOffer = product.contents.length > 1
  return (
    <Container
      product={product}
      className={cx(styles.Container, {
        [styles.MultiItemContainer]: isMultiItemOffer,
        [styles.SingleItemContainer]: !isMultiItemOffer,
      })}
    >
      <Countdown product={product as StoreOfferProduct} />
      {ribbons.length === 0 ? <ValueBadge product={product} /> : <Ribbons ribbons={ribbons} />}
      <BrawlStarsHeading product={product} />
      <BrawlStarsOfferCardContent product={product} />
      <Footer product={product} className={styles.Footer} />
    </Container>
  )
}
